import { Component, OnInit } from '@angular/core';

@Component({
    selector    : 'app-baja-plataforma',
    templateUrl : './baja-plataforma.component.html',
    styleUrls   : ['./baja-plataforma.component.scss']
})
export class BajaPlataformaComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
